import { Injectable } from '@angular/core';
import {Observable, of, tap} from 'rxjs';
import {HttpClient} from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class AuthService {

  constructor(private http: HttpClient) {}

  getToken() {
    return localStorage.getItem('access_token')
  }

  setToken(token: string) {
    localStorage.setItem('access_token', token);
  }

  logout() {
    return this.http.post('/api/logout', {}).pipe(
      tap(() => localStorage.removeItem('access_token'))
    )
  }

  removeToken() {
    localStorage.removeItem('access_token');
  }

  login() {
    return this.http.get<{url: string}>('/api/auth').pipe(
      tap((res: {url: string}) => { if(res.url) { window.location.href = res.url }})
    );
  }

  requestToken(temporaryToken: string) {
    this.setToken(temporaryToken as string)
    return this.http.post<{accessToken: string, isSuccess: boolean, tokenType: string}>('/api/tokens', {code: temporaryToken}).pipe(
      tap((token) => {
        this.setToken(token?.accessToken as string)
      })
    )
  }
}
